import type { ReactNode } from "react";

const FALLBACK_BADGE_CLASSES = "bg-slate-100 text-slate-600 border-slate-200";

/**
 * Small status/tier badge shared across the Storage Ops panels. Callers pass
 * the color classes looked up from a badge-class map; unknown values fall
 * back to a neutral slate style.
 */
function Badge({
  label,
  colorClasses,
}: {
  label: ReactNode;
  colorClasses?: string;
}) {
  return (
    <span
      className={`inline-block rounded border px-2 py-0.5 text-xs font-semibold ${
        colorClasses ?? FALLBACK_BADGE_CLASSES
      }`}
    >
      {label}
    </span>
  );
}

export default Badge;
